export const isMarketplaceEnabled =
  process.env.MARKETPLACE_ENABLED === 'true' ||
  process.env.NEXT_PUBLIC_MARKETPLACE_ENABLED === 'true'
